import { render, staticRenderFns } from "./VendorAssignment.vue?vue&type=template&id=3a0f6554"
import script from "./VendorAssignment.vue?vue&type=script&lang=js"
export * from "./VendorAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports